import { Scene, Object3D, Vector3, Euler } from "three";
import { IGameObject } from "../IGameObject";
import Loader from "../Loader";
import { IOnlineObject } from "../OnlineObjects";
import World from "../World";

class Flag implements IGameObject {
    /** The online object id */
    public id: string;

    public model: Object3D | null;

    public position: Vector3;

    public rotation: Euler;

    public velocity: Vector3;

    public world: World;

    public type: "red-flag" | "blue-flag";

    constructor(
        scene: Scene,
        loader: Loader,
        colour: "red" | "blue",
        world: World,
        id: string
    ) {
        this.model = null;
        loader.loadModel(
            `${process.env.ASSET_URL}/models/${colour}-flag.dae`,
            (model: Object3D) => {
                scene.add(model);
                this.model = model;
                this.update();
            }
        );
        this.position = new Vector3();
        this.rotation = new Euler();
        this.velocity = new Vector3();

        this.world = world;

        this.type = `${colour}-flag` as const;

        this.id = id;
    }

    public update(): void {
        const { position, model } = this;
        model?.position.set(position.x, position.y, position.z);
    }

    /** New position information from server */
    public refresh(onlineObject: IOnlineObject): void {
        // Ignore Y, flags should always glue to the ground.
        const y = this.world.getGroundIntersection(onlineObject.position, 0);
        this.position.set(onlineObject.position.x, y, onlineObject.position.z);
        console.log(
            `Flag location: ${onlineObject.position.x}, ${onlineObject.position.y}`
        );
    }
}

export default Flag;
